import { Controller } from "@hotwired/stimulus"

import 'tom-select'
import TomSelect from "tom-select"

// Connects to data-controller="font-awesome-select"
export default class extends Controller {
  connect() {
    var settings = {
      maxOptions: null,
      valueField: 'id',
      labelField: 'id',
      searchField: [],
      load: function (query, callback) {
        var self = this;
        var url = "https://api.fontawesome.com";
        fetch(
          url,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              query: "query { search (version: \"6.7.2\", query: \"" + query + "\", first: 20) { id } }"
            })
          }
        )
        .then(response => response.json())
        .then(json => {
          self.clearOptions();
          callback(json.data.search);
        }).catch(() => {
          callback();
        });
      },
      render: {
        option: function (data, escape) {
          return `<div><i class="fal fa-${escape(data.id)}"></i>&nbsp;` + escape(data.id) + '</div>';
        },
        item: function (data, escape) {
          return `<div><i class="fal fa-${escape(data.id)}"></i>&nbsp;` + escape(data.id) + '</div>';
        }
      }
    }

    new TomSelect(this.element, settings);
  }
}
